<script>
	// import Vue from 'vue'
	import Store from "./store"
	import {
		uploadImg
	} from "./utils/api.js"
	import {setStorage,} from "@/service/storage";
	import {
		updateText,
		setAppId
	} from "@/utils/config.js"
	import {
		isWechat
	} from "@/utils/index.js"
	import { checkApkSign } from "/utils/checkSign"
	// import { wgs84_to_gcj02 } from "utils/gps_to_gcj02.js"
	import { useGetGlobalProperties } from "@/utils/hooks.js"
	const App = getApp({allowDefault: true})
	export default {
		onLaunch: function(options) {
			const global = useGetGlobalProperties()
			console.log(options)
			// 普通分享用pid
			if (options.query.pid) {
				setStorage('pid', options.query.pid)
			}
			if (options.query.agent_pid) {
				setStorage('agent_pid', options.query.agent_pid)
			}
			if (options.query.agent_id) {
				setStorage('agent_id', options.query.agent_id)
			}
			// uni.showModal({
			// 	title: "optinos",
			// 	content: JSON.stringify(options)
			// })
			if (options.query.jwjrid) {
				
				setStorage('jwjrid', options.query.jwjrid)
			}
			
			
            // #ifdef H5
			if (window.__wxjs_is_wkwebview) { // ios
				console.log("IOS,初始化页面路径到缓存", window.location.href.split("#")[0])
				setStorage('wxIosUrl', window.location.href.split("#")[0])
			}
			if (uni.getStorageSync('wechatType')) {
				setAppId(uni.getStorageSync('wechatType'))
			}
            // 判断是哪一个公众号进入的
            if (options.query.wechatType) {
				setAppId(options.query.wechatType)
            }
            // #endif
			
			let that = this
			uni.getSystemInfo({
				success: (e) => {
					console.log("系统信息：",e)
					
					// #ifdef APP-PLUS
					
					global.isAndroid = e.platform == 'android'
					global.isIos = e.platform == 'ios'
					that.$store.state.systemInfo = e
					if (e.platform == 'android') {
						//如果是安卓运行环境，校验应用签名是否正确  
						if(!checkApkSign('SHA1')){
							uni.showModal({
								title: "签名错误",
								content: "签名异常，请到各大应用市场下载安装正版",
								showCancel: false,
								success: (confirm) => {
									plus.runtime.quit();  
								}
							})
						}  
					}
					const jihuoDate = uni.getStorageSync('jihuo')
					if (jihuoDate) {
						const thatDate = new Date().getTime()
						const jihuoDate1 = uni.getStorageSync('jihuo1')
						if (!jihuoDate1 && thatDate - jihuoDate > 1000*60*60*24) {
							this.$api.baidu_action({
								oaid: e.oaid || '',
								ua: e.ua,
								a_type: "retain_1day"
							}).then(([berr, bres]) => {
								uni.setStorageSync('jihuo1', new Date().getTime())
								console.log("百度激活params:",{
									oaid: e.oaid || '',
									ua: e.ua,
									a_type: "retain_1day"
								})
								console.log("百度激活res:", bres)
							})
						}
					} else {
						uni.setStorageSync('jihuo', new Date().getTime())
						this.$api.baidu_action({
							oaid: e.oaid || '',
							ua: e.ua,
							a_type: "activate"
						}).then(([berr, bres]) => {
							
							console.log("百度激活params:",{
								oaid: e.oaid || '',
								ua: e.ua,
								a_type: "activate"
							})
							console.log("百度激活res:", bres)
						})
					}
					// #endif
					
					// console.log("systemInfo ", e)
					// #ifndef MP
					global.StatusBar = e.statusBarHeight;
					if (e.platform == 'android') {
						global.CustomBar = e.statusBarHeight + 50;
					} else {
						global.CustomBar = e.statusBarHeight + 45;
					};
					
					that.globalData.nowSystem = Number(e.system.substring(4, 6)) // 版本号
					that.globalData.nowPlatform = e.platform // 系统
					// #endif

					// #ifdef MP-WEIXIN
					global.StatusBar = e.statusBarHeight;
					let custom = wx.getMenuButtonBoundingClientRect();
					global.Custom = custom;
					global.CustomBar = custom.bottom + custom.top - e.statusBarHeight;
					// #endif		

					// #ifdef MP-ALIPAY
					global.StatusBar = e.statusBarHeight;
					global.CustomBar = e.statusBarHeight + e.titleBarHeight;
					// #endif
				}
			})
			// this.$store.dispatch('GetThreeCity')
			// #ifdef APP-PLUS
			if (this.$store.state.longitude && this.$store.state.latitude) {
				this.checkDiffrentCity()
			}
			// #endif
			// #ifdef H5
			console.log(this.$route.fullPath)
			if (this.$route.fullPath === '/' || this.$route.fullPath.match('pages/master/liliaoshi')) {
				// 过三秒之后检查地址
				setTimeout(() => {
					this.checkDiffrentCity()
				}, 3000)
			}
			// #endif
			if(this.$store.state.userInfo.id) {
				this.$store.dispatch('getUser')
				this.$store.dispatch('isExistOrder')
			}
		},
		globalData: {
			uploadImg,
			arrTwo:[],
			nowSystem:'',//当前手机版本号
			nowPlatform:''//当前手机系统
		},
		onShow: function(option) {
			
		},
		onHide: function() {
			// #ifdef APP-PLUS
			// this.removeLocation()
			// #endif
			console.log('App Hide')
		},
		methods: {	
			async checkDiffrentCity(){
				if (Store.state.myCityInfo && Store.state.myCityInfo.id) {
					if (this.isAndroid) {
						// #ifdef APP-PLUS
						// const [err, version] = await this.$api.Version({
						// 	type_limit: 11
						// })
						// if (version && version.code == 10000) {
						// 	if (version.data[2].system_value == updateText) {
						// 		return
						// 	}
						// }
						// #endif
						
					}
					
					
					let locationStr = ''
					if (Store.state.longitude && Store.state.latitude) {
						locationStr = Store.state.latitude + ',' + Store.state.longitude
					} else {
						const locationResult = await this.getLocation()
						if (locationResult.flag) {
							const { address } = locationResult
							locationStr = address.latitude + "," + address.longitude
						}
					}
					console.log(locationStr)
					if (locationStr) {
						const [err,res1] = await this.$api.searchCity({location: locationStr})
						if (err) return
						if (res1.code == 10000) {
							// if (!res1.data.name)
							console.log("获取的城市：",res1.data.name,"本地城市：", Store.state.myCityInfo.name)
							if (Array.isArray(res1.data) && res1.data.length === 0) {
								Store.state.myCityInfo = {
									id: 3,
									name: '重庆'
								}
								uni.showToast({
									title: "您的城市暂未开通，默认显示重庆市",
									icon: 'none'
								})
								return 
							}
							// if (!Store.state.myCityInfo.name) {
							// 	// Store.state.myCityInfo.name ? 
							// 	Store.commit('setCityInfo', res1.data.id)
							// }
							else if (res1.data.name !== Store.state.myCityInfo.name ) {
								console.log("出发到这里")
								uni.showModal({
									content: `是否切换到${res1.data.name}?`,
									title: "提示",
									success: (con) => {
										if (con.confirm) {
											Store.commit('setCityInfo', res1.data)
											uni.reLaunch({
												url: "/pages/index/index"
											})
										}
									}
								})
							}
						}
					}
				
				}
			},
			getLocation() {
				return new Promise(async (resolve, reject) => {
					// #ifdef H5
					const isWx = isWechat()
					if (isWx && process.env.NODE_ENV == 'production') {
						this.$jwx.GetInfoMation()
							.then(async (res) =>{
								console.log("获取页面配置", res)
								if (res) {
									const address = await this.$jwx.chooseAddress()
									if(address){
										Store.state.longitude = address.longitude
										Store.state.latitude = address.latitude
										setStorage('longitude', address.longitude)
										setStorage('latitude', address.latitude)
										resolve({flag: true, address})
									} else {
										 
										resolve({flag: false, err: '获取定位失败'})
									}
									
								} else {
									 
									resolve({flag: false, err: '获取定位失败'})
								}
							})
							.catch((err) => {
								 
								console.log("定位失败", err || 'err')
								resolve({flag: false, err: '获取定位失败'})
							})
					} else {
						uni.getLocation({
							type: 'wgs84',
							success(res) {
								// const lglat = wgs84_to_gcj02(res.longitude, res.latitude)
								Store.state.longitude =res.longitude
								Store.state.latitude = res.latitude
								setStorage('longitude', res.longitude)
								setStorage('latitude', res.latitude)
								resolve({flag: true, address: res})
							},
							fail: (err)=> {
								 
								resolve({flag: false, err})
								console.log(err)
							}
						})
					}
					
					// #endif
					
					// #ifndef H5
					if (uni.getSystemInfoSync().platform == 'android') {
						let result = await this.$store.dispatch("permissionToast/requestPermissions",'ACCESS_FINE_LOCATION')
						if (result !== 1) return
					}
					uni.getLocation({
						type: 'wgs84',
						success(res) {
							// const lglat = wgs84_to_gcj02(res.longitude, res.latitude)
							Store.state.longitude =res.longitude
							Store.state.latitude = res.latitude
							setStorage('longitude', res.longitude)
							setStorage('latitude', res.latitude)
							resolve({flag: true, address: res})
						},
						fail: (err) => {
							 
							console.log(err)
							resolve({flag: false, err})
						}
					})
					// #endif
				
				})
			},
			removeLocation(){
				Store.state.longitude = ''
				Store.state.latitude = ''
				setStorage('longitude', '')
				setStorage('latitude', '')
				
			}
		},
		
	}
</script>

<style lang="less">
	@import "static/css/common/common.less";
	@import "static/css/index.less";
	@import "App.css";
    @import "static/iconfont/iconfont.css";	
</style>
